import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hinjewadicabservice() {



    const cardData = {

keyword: "Hinjewadi Cab Service",

headingDescription:
    "Rising Cab Service offers reliable and affordable Hinjewadi Cab Service for IT professionals, families, and business travelers with convenient local and outstation travel options. We provide quick airport transfers, railway station drops, daily commuting, and comfortable long-distance trips from Hinjewadi to popular destinations across Maharashtra and India. Our fleet includes Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by experienced chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe and hassle-free travel experience.",

topPlaces: [
    {
        title: "Lonavala",
        description:
            "Lonavala is one of the most popular weekend getaways near Hinjewadi, known for its misty hills, waterfalls, and scenic valleys. Attractions like Bhushi Dam, Tiger Point, and Rajmachi Fort make it a perfect short trip destination for relaxation and nature lovers."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station famous for its cool climate, strawberry farms, and breathtaking viewpoints like Arthur’s Seat and Elephant’s Head Point. It is ideal for family vacations and romantic getaways from Hinjewadi."
    },
    {
        title: "Goa",
        description:
            "Goa is a top long-distance travel destination from Hinjewadi known for its beaches, nightlife, forts, and Portuguese culture. Popular spots include Baga Beach, Calangute Beach, Fort Aguada, and Anjuna Beach."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra, home to Sai Baba Samadhi Mandir. Devotees from Hinjewadi frequently travel here for spiritual blessings and peaceful darshan."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a holy city known for Trimbakeshwar Jyotirlinga, Panchvati, and Godavari river ghats. It is also famous for vineyards and is a perfect mix of spirituality and leisure travel."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is a Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest and wildlife sanctuary. It is a popular spiritual and trekking destination from Hinjewadi."
    },
    {
        title: "Mumbai",
        description:
            "Mumbai is Maharashtra’s capital city known for Gateway of India, Marine Drive, Siddhivinayak Temple, and Juhu Beach. It is a major business, tourism, and cultural destination from Hinjewadi."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a peaceful coastal destination known for clean beaches, sea forts, and relaxing weekend stays. It is ideal for short trips from Hinjewadi with family and friends."
    },
    {
        title: "Pune City Darshan",
        description:
            "Pune city offers historical and cultural attractions like Shaniwar Wada, Aga Khan Palace, Dagadusheth Ganpati, and Sinhagad Fort, making it a great local sightseeing option from Hinjewadi."
    },
    {
        title: "Lavasa",
        description:
            "Lavasa is a planned hill city near Pune known for its lakeside beauty, colorful buildings, and peaceful environment. It is a popular short getaway destination from Hinjewadi."
    }
],



services: [
    {
        name: "Cab Service in Hinjewadi",
        description:
            "Rising Cab Service offers reliable Cab Service in Hinjewadi for daily commuters, IT professionals, corporate employees, and local travelers. We provide well-maintained AC cabs, professional drivers, and 24x7 availability for safe and comfortable travel across Hinjewadi and nearby Pune locations. Our service ensures timely pickups, smooth rides, and affordable pricing for both short and long-distance journeys."
    },
    {
        name: "Taxi Service in Hinjewadi",
        description:
            "Our Taxi Service in Hinjewadi is designed for convenient and hassle-free travel within Pune city and surrounding areas. Rising Cab Service offers clean vehicles, experienced drivers, and flexible booking options for office commutes, airport transfers, and daily travel needs with complete comfort and reliability."
    },
    {
        name: "Hinjewadi Cab Service",
        description:
            "Rising Cab Service provides Hinjewadi Cab Service for IT professionals, business travelers, and residents. We ensure quick availability, affordable fares, and safe transportation with a fleet of sedans, SUVs, and premium cars suitable for all travel requirements."
    },
    {
        name: "Hinjewadi Taxi Service",
        description:
            "Book Hinjewadi Taxi Service with Rising Cab Service for smooth and comfortable rides across Pune and outstation destinations. Our service includes trained drivers, sanitized vehicles, and flexible travel schedules for a stress-free travel experience."
    },
    {
        name: "Best Cab Service in Hinjewadi",
        description:
            "Rising Cab Service offers the Best Cab Service in Hinjewadi with reliable transportation, transparent pricing, and 24x7 support. We ensure high-quality travel service for corporate clients, families, and daily commuters with maximum comfort and safety."
    },
    {
        name: "Online Cab Booking Hinjewadi",
        description:
            "Our Online Cab Booking Hinjewadi system allows customers to book cabs instantly with easy steps, transparent pricing, and quick confirmation. Rising Cab Service ensures a seamless booking experience for local and outstation travel needs."
    },
    {
        name: "Cab Hire in Hinjewadi",
        description:
            "Rising Cab Service offers Cab Hire in Hinjewadi for hourly rentals, full-day trips, corporate travel, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles."
    },
    {
        name: "Taxi Booking Hinjewadi",
        description:
            "Book Taxi Booking Hinjewadi with Rising Cab Service for fast and reliable transportation. We ensure timely service, clean vehicles, and affordable pricing for all types of travel requirements."
    },
    {
        name: "Local Cab Service Hinjewadi",
        description:
            "Our Local Cab Service Hinjewadi is ideal for daily commuting, shopping trips, office travel, and nearby transportation needs. Rising Cab Service guarantees safe, budget-friendly, and comfortable rides within Hinjewadi and Pune."
    },
    {
        name: "Outstation Cab Service Hinjewadi",
        description:
            "Rising Cab Service provides Outstation Cab Service Hinjewadi for long-distance travel to destinations like Mumbai, Shirdi, Nashik, Goa, and Mahabaleshwar. We offer comfortable vehicles, experienced drivers, and flexible one-way or round-trip options."
    },
    {
        name: "Cab Service in Hinjewadi Pune",
        description:
            "Book Cab Service in Hinjewadi Pune with Rising Cab Service for reliable local and intercity travel. We provide 24x7 availability, professional drivers, and well-maintained vehicles for a smooth travel experience."
    },
    {
        name: "Taxi Service in Hinjewadi Pune",
        description:
            "Our Taxi Service in Hinjewadi Pune ensures safe and comfortable transportation for IT professionals, families, and tourists with flexible booking options and affordable fares."
    },
    {
        name: "Hinjewadi to Pune Airport Cab",
        description:
            "Rising Cab Service offers Hinjewadi to Pune Airport Cab with timely pickups, comfortable AC vehicles, and professional drivers ensuring stress-free airport transfers."
    },
    {
        name: "Pune Airport to Hinjewadi Cab",
        description:
            "Book Pune Airport to Hinjewadi Cab with Rising Cab Service for reliable and on-time pickup service. We ensure smooth transfers with clean vehicles and experienced drivers."
    },
    {
        name: "Cab Booking in Hinjewadi",
        description:
            "Our Cab Booking in Hinjewadi service allows quick and easy reservations with instant confirmation, transparent pricing, and multiple vehicle options for all travel needs."
    },
    {
        name: "Cheap Cab Service in Hinjewadi",
        description:
            "Rising Cab Service provides Cheap Cab Service in Hinjewadi without compromising on quality. We offer budget-friendly travel solutions with safe and comfortable rides."
    },
    {
        name: "Affordable Taxi Service Hinjewadi",
        description:
            "Our Affordable Taxi Service Hinjewadi ensures economical travel options for daily commuters, families, and corporate travelers with reliable service and clean vehicles."
    },
    {
        name: "Hinjewadi to Mumbai Cab",
        description:
            "Rising Cab Service offers Hinjewadi to Mumbai Cab for comfortable intercity travel with experienced drivers, flexible timing, and safe highway journeys."
    },
    {
        name: "Hinjewadi to Shirdi Cab",
        description:
            "Book Hinjewadi to Shirdi Cab with Rising Cab Service for a smooth pilgrimage trip to Sai Baba temple with comfortable vehicles and reliable service."
    },
    {
        name: "Hinjewadi to Nashik Cab",
        description:
            "Rising Cab Service provides Hinjewadi to Nashik Cab for family trips, pilgrimages, and business travel with safe and comfortable transportation."
    },
    {
        name: "Hinjewadi to Mahabaleshwar Cab",
        description:
            "Our Hinjewadi to Mahabaleshwar Cab service ensures a scenic and comfortable hill station journey with professional drivers and well-maintained vehicles."
    },
    {
        name: "Hinjewadi to Goa Cab",
        description:
            "Book Hinjewadi to Goa Cab with Rising Cab Service for a relaxing long-distance beach vacation trip with safe driving and comfortable travel experience."
    },
    {
        name: "Hinjewadi to Kolhapur Cab",
        description:
            "Rising Cab Service provides Hinjewadi to Kolhapur Cab for pilgrimage and family travel with reliable drivers and flexible booking options."
    },
    {
        name: "Hinjewadi to Lonavala Cab",
        description:
            "Our Hinjewadi to Lonavala Cab service offers quick weekend getaway travel with comfortable vehicles and experienced chauffeurs."
    },
    {
        name: "Outstation Taxi Service Hinjewadi",
        description:
            "Rising Cab Service provides Outstation Taxi Service Hinjewadi for long-distance travel across Maharashtra and India with safe and reliable transportation."
    },
    {
        name: "One Way Outstation Cab Hinjewadi",
        description:
            "Book One Way Outstation Cab Hinjewadi for budget-friendly travel options without return booking requirements and flexible drop locations."
    },
    {
        name: "Round Trip Cab Booking Hinjewadi",
        description:
            "Our Round Trip Cab Booking Hinjewadi service offers complete travel packages with waiting time and return journey included for convenience."
    },
    {
        name: "Cab Service in Hinjewadi Phase 1",
        description:
            "Rising Cab Service provides Cab Service in Hinjewadi Phase 1 for IT parks, residential areas, and office commute with quick availability and reliable service."
    },
    {
        name: "Cab Service in Hinjewadi Phase 2",
        description:
            "Book Cab Service in Hinjewadi Phase 2 with Rising Cab Service for daily travel, corporate transport, and local commuting needs."
    },
    {
        name: "Cab Service in Hinjewadi Phase 3",
        description:
            "Our Cab Service in Hinjewadi Phase 3 ensures safe and affordable transportation for IT professionals and residents with 24x7 availability."
    },
    {
        name: "Taxi Service in Rajiv Gandhi Infotech Park",
        description:
            "Rising Cab Service provides Taxi Service in Rajiv Gandhi Infotech Park for corporate employees with timely pickups, professional drivers, and comfortable rides."
    },
    {
        name: "Cab Service Near Wipro Circle Hinjewadi",
        description:
            "Book Cab Service Near Wipro Circle Hinjewadi for quick and reliable transportation for office commute and daily travel needs."
    },
    {
        name: "Taxi Service Near Infosys Hinjewadi",
        description:
            "Our Taxi Service Near Infosys Hinjewadi ensures safe and timely rides for IT professionals with clean vehicles and experienced drivers."
    }
],

tableData: [
    ["Cab Service in Hinjewadi", "Taxi Service in Hinjewadi"],
    ["Hinjewadi Cab Service", "Hinjewadi Taxi Service"],
    ["Best Cab Service in Hinjewadi", "Online Cab Booking Hinjewadi"],
    ["Cab Hire in Hinjewadi", "Taxi Booking Hinjewadi"],
    ["Local Cab Service Hinjewadi", "Outstation Cab Service Hinjewadi"],
    ["Cab Service in Hinjewadi Pune", "Taxi Service in Hinjewadi Pune"],
    ["Hinjewadi to Pune Airport Cab", "Pune Airport to Hinjewadi Cab"],
    ["Cab Booking in Hinjewadi", "Cheap Cab Service in Hinjewadi"],
    ["Affordable Taxi Service Hinjewadi", "Hinjewadi to Mumbai Cab"],
    ["Hinjewadi to Shirdi Cab", "Hinjewadi to Nashik Cab"],
    ["Hinjewadi to Mahabaleshwar Cab", "Hinjewadi to Goa Cab"],
    ["Hinjewadi to Kolhapur Cab", "Hinjewadi to Lonavala Cab"],
    ["Outstation Taxi Service Hinjewadi", "One Way Outstation Cab Hinjewadi"],
    ["Round Trip Cab Booking Hinjewadi", "Cab Service in Hinjewadi Phase 1"],
    ["Cab Service in Hinjewadi Phase 2", "Cab Service in Hinjewadi Phase 3"],
    ["Taxi Service in Rajiv Gandhi Infotech Park", "Cab Service Near Wipro Circle Hinjewadi"],
    ["Taxi Service Near Infosys Hinjewadi", "Cab Service in Hinjewadi"]
],





whychoose: [
    {
        WhyChooseheading: "Quick and Convenient Transportation in Hinjewadi",
        WhyChoosedescription: "Rising Cab Service offers dependable cab solutions for daily commuting, office travel, airport transfers, and outstation journeys from Hinjewadi."
    },
    {
        WhyChooseheading: "Preferred Choice for IT Professionals",
        WhyChoosedescription: "Our cab services are widely used by employees working in Rajiv Gandhi Infotech Park and nearby corporate offices for hassle-free transportation."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "From Sedan cars and SUVs to Innova Crysta, Tempo Travellers, and premium vehicles, we provide transportation solutions for every travel requirement."
    },
    {
        WhyChooseheading: "Flexible Booking for Any Travel Need",
        WhyChoosedescription: "Whether you require a local city ride, airport pickup, business travel, weekend getaway, or outstation trip, our services can be tailored accordingly."
    },
    {
        WhyChooseheading: "Reliable Airport Transfer Services",
        WhyChoosedescription: "Travelers can enjoy timely pickup and drop services between Hinjewadi and Pune Airport with professional drivers and comfortable vehicles."
    },
    {
        WhyChooseheading: "Travel Support Available Throughout the Day",
        WhyChoosedescription: "Our booking team remains available to assist customers with ride scheduling, route planning, and travel-related requirements."
    },
    {
        WhyChooseheading: "Safe Rides for Families and Corporate Travelers",
        WhyChoosedescription: "Every journey is supported by trained drivers and regularly maintained vehicles to ensure a secure and pleasant travel experience."
    },
    {
        WhyChooseheading: "Cost-Effective Travel Solutions",
        WhyChoosedescription: "Rising Cab Service provides affordable transportation options with transparent pricing and dependable service quality."
    }
]
};

const faqData = [
    {
        question: "Which areas near Hinjewadi are covered by your cab service?",
        answer: "Our services cover Hinjewadi Phase 1, Phase 2, Phase 3, Wakad, Baner, Marunji, Tathawade, Mahalunge, and nearby areas."
    },
    {
        question: "Is airport transportation available from Hinjewadi?",
        answer: "Yes, we provide convenient pickup and drop services between Hinjewadi and Pune Airport."
    },
    {
        question: "Can office employees schedule daily cab rides?",
        answer: "Yes, regular transportation arrangements can be made for office commuters and corporate employees."
    },
    {
        question: "What types of vehicles can be booked?",
        answer: "Customers can choose from Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and premium vehicle categories."
    },
    {
        question: "Are outstation trips available from Hinjewadi?",
        answer: "Yes, we provide cab services from Hinjewadi to destinations across Maharashtra and neighboring states."
    },
    {
        question: "How early should a cab be reserved?",
        answer: "Advance booking is recommended, especially during weekends, holidays, and peak travel hours."
    },
    {
        question: "Can groups hire larger vehicles from Hinjewadi?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family functions, tours, and corporate outings."
    },
    {
        question: "Are business travelers among your regular customers?",
        answer: "Yes, many corporate professionals and IT employees use our services for meetings, airport transfers, and official travel."
    },
    {
        question: "Do you offer one-way and round-trip services?",
        answer: "Yes, both one-way and round-trip travel options are available for local and outstation journeys."
    },
    {
        question: "How can a customer reserve a cab in Hinjewadi?",
        answer: "Bookings can be made through phone calls, WhatsApp, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Aditya Kulkarni",
        feedback:
            "Using Rising Cab Service for my office and airport travel has been extremely convenient. The drivers are punctual, and the vehicles are always maintained in excellent condition.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Patwardhan",
        feedback:
            "Finding reliable transportation in Hinjewadi became much easier after choosing Rising Cab Service. The booking process was simple, and the travel experience was consistently smooth.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Hinjewadi Cab Service",
"image": "https://www.risingcabservice.com/assets/images/hinjewadi-cab-service.jpg",
"description": "Book Hinjewadi Cab Service with Rising Cab Service for local travel, airport transfers, corporate rides, and outstation trips. Enjoy safe, affordable, and reliable taxi service in Hinjewadi with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/hinjewadi-cab-service"
}
};









    return (
        <div>

<Helmet>
  <title>Hinjewadi Cab Service | Local & Airport Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Hinjewadi Cab Service for local rides, airport transfers, corporate travel, and outstation trips. Affordable and reliable taxi service in Hinjewadi with AC cars and professional drivers."
/>

<meta
 name="keywords"
 content="Cab Service in Hinjewadi, Taxi Service in Hinjewadi, Hinjewadi Cab Service, Hinjewadi Taxi Service, Best Cab Service in Hinjewadi, Online Cab Booking Hinjewadi, Cab Hire in Hinjewadi, Taxi Booking Hinjewadi, Local Cab Service Hinjewadi, Outstation Cab Service Hinjewadi, Cab Service in Hinjewadi Pune, Taxi Service in Hinjewadi Pune, Hinjewadi to Pune Airport Cab, Pune Airport to Hinjewadi Cab, Cab Booking in Hinjewadi, Cheap Cab Service in Hinjewadi, Affordable Taxi Service Hinjewadi, Hinjewadi to Mumbai Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Hinjewadicabservice;